import React from 'react'

const DrapeauTunisie = () => {
  return (
    <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="23" height="16" stroke="#5754E5" strokeOpacity="0.15"/>
        <path d="M23 1H1V16H23V1Z" fill="url(#paint0_linear_10403_49066)"/>
        <path d="M12.0013 12.8998C14.3775 12.8998 16.3034 10.9297 16.3034 8.49997C16.3034 6.07022 14.3771 4.1001 12.0013 4.1001C9.62509 4.1001 7.69922 6.07022 7.69922 8.49997C7.69922 10.9297 9.62509 12.8998 12.0013 12.8998ZM13.1542 9.26857L12.3319 10.4391L12.3244 8.99775L10.9817 8.55957L12.3197 8.10709L12.3123 6.66574L13.1468 7.82721L14.4848 7.37473L13.6624 8.54527L14.4969 9.70722L13.1542 9.26857ZM12.0353 5.21342C12.9715 5.21342 13.8144 5.61679 14.4097 6.26237C13.9985 5.99441 13.5109 5.83897 12.9873 5.83897C11.5221 5.83897 10.3342 7.05385 10.3342 8.55242C10.3342 10.051 11.5221 11.2659 12.9873 11.2659C13.5109 11.2659 13.9985 11.11 14.4097 10.8425C13.8144 11.4876 12.971 11.8914 12.0353 11.8914C10.2326 11.8914 8.77055 10.3967 8.77055 8.55242C8.77055 6.70817 10.2321 5.21342 12.0353 5.21342Z" fill="white"/>
        <defs>
        <linearGradient id="paint0_linear_10403_49066" x1="1" y1="8.49993" x2="22.9998" y2="8.49993" gradientUnits="userSpaceOnUse">
        <stop stopColor="#CF1400"/>
        <stop offset="1" stopColor="#CF1400"/>
        </linearGradient>
        </defs>
    
    </svg>

  )
}

export default DrapeauTunisie
